<template>
  <div>
    <apexchart v-if='type'
      :id='id' :width="width"
      :height='height'
      :minHeight="0"
      :type="type"
      :options="options"
      :series="series"
      @mounted="handleChartMounted"
      ></apexchart>
  </div>
</template>
<script>
export default {
  data(){
    return {
      width: '240',
      height: '50',
      type: null,
      options: {},
      series: [],
      id: null,
      chartInstance: null,
    }
  },
  props:{
    data: {
      type: Object,
      required: true
    },
    change: {
      type: Number,
      default(){
        return 0
      }
    },
  },
  beforeMount() {
    this.render()
  },
  methods: {
    render(){
      try {
        this.id = this.id | Math.random().toString(36).substr(2, 9);
        if(this.data){
          this.type = this.data.type
          this.options = this.data.options
          this.series = this.data.series
          if (this.data.width){
            this.width = this.data.width
          }
          if (this.data.height){
            this.height = this.data.height
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleChartMounted(chartInstance) {
      this.chartInstance = chartInstance;
    }
  },
  watch: {
    change: {
      deep: true,
      handler: function (nv) {
        if(this.data){
          this.data.options.chart.height = this.height
          this.options = this.data.options
          this.series = this.data.series
          this.height = this.height
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/GraphApexChart.vue